module.exports = __webpack_public_path__ + "static/media/navbar_fondo_rojo.bae6e9ae.png";